import { DisableNextRegimeStep } from "routes/regime/plugins/publishing/publishing-event-definitions.mjs"
import { useState } from "react"

export function useIsNextRegimeStepDisabled(step) {
    const [stepStatuses, setStepStatuses] = useState({})

    DisableNextRegimeStep(step).useEvent((props) => {
        const { id, disabled, message } = props

        setStepStatuses((prev) => ({
            ...prev,
            [id]: { disabled, message },
        }))
    }, [])

    const entries = Object.values(stepStatuses)
    const disabled = entries.some((e) => e.disabled)
    const messages = entries.filter((e) => e.disabled && e.message).map((e) => e.message)

    return { disabled, message: messages[0], messages }
}
